import * as Sentry from "@sentry/react";
import { Protected } from "@stardeck-customer-apps/project-auth";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import { ApiGuide } from "@/pages/admin/api-guide";
import { CategoriesPage } from "@/pages/admin/categories";
import { AdminIndex } from "@/pages/admin/index";
import { AdminLogin } from "@/pages/admin/login";
import { MediaLibrary } from "@/pages/admin/media-library";
import { PostEditor } from "@/pages/admin/post-editor";
import { PostsList } from "@/pages/admin/posts-list";
import { NotFound } from "@/pages/not-found";
import { Unauthorized } from "@/pages/unauthorized";
import { Providers } from "@/providers";

function AppRoutes() {
  return (
    <Router>
      <Providers>
        <main>
          <Sentry.ErrorBoundary fallback={<p>An error has occurred</p>}>
            <Routes>
              {/* Login */}
              <Route path="/login" element={<AdminLogin />} />
              <Route path="/unauthorized" element={<Unauthorized />} />

              {/* Protected CMS routes */}
              <Route
                path="/"
                element={
                  <Protected
                    requiredPermission="deployment:admin-panel:write"
                    redirectTo="/login"
                    redirectOnUnauthorizedTo="/login"
                  >
                    <AdminIndex />
                  </Protected>
                }
              />
              <Route
                path="/posts/:type"
                element={
                  <Protected
                    requiredPermission="deployment:admin-panel:write"
                    redirectTo="/login"
                    redirectOnUnauthorizedTo="/login"
                  >
                    <PostsList />
                  </Protected>
                }
              />
              <Route
                path="/posts/:type/:id"
                element={
                  <Protected
                    requiredPermission="deployment:admin-panel:write"
                    redirectTo="/login"
                    redirectOnUnauthorizedTo="/login"
                  >
                    <PostEditor />
                  </Protected>
                }
              />
              <Route
                path="/media"
                element={
                  <Protected
                    requiredPermission="deployment:admin-panel:write"
                    redirectTo="/login"
                    redirectOnUnauthorizedTo="/login"
                  >
                    <MediaLibrary />
                  </Protected>
                }
              />
              <Route
                path="/categories"
                element={
                  <Protected
                    requiredPermission="deployment:admin-panel:write"
                    redirectTo="/login"
                    redirectOnUnauthorizedTo="/login"
                  >
                    <CategoriesPage />
                  </Protected>
                }
              />
              <Route
                path="/api-guide"
                element={
                  <Protected
                    requiredPermission="deployment:admin-panel:write"
                    redirectTo="/login"
                    redirectOnUnauthorizedTo="/login"
                  >
                    <ApiGuide />
                  </Protected>
                }
              />

              {/* 404 */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Sentry.ErrorBoundary>
        </main>
      </Providers>
    </Router>
  );
}

export default AppRoutes;
